import React from 'react';

// Rosa dos ventos — agulha que aponta o sentido de marcha do veículo
// (heading em graus, 0=N, 90=E, 180=S, 270=O). SVG estático + rótulo cardinal.
// Sem animação e sem dependências — desenho leve. Extraído de MapViewGoogle
// para ser reutilizável (histórico/replay + acompanhamento ao vivo da OT).
export default function CompassRose({ heading = 0, lang = 'pt', size = 42 }) {
  const deg = ((Number(heading) || 0) % 360 + 360) % 360;
  const dirs = lang === 'pt'
    ? ['N', 'NE', 'E', 'SE', 'S', 'SO', 'O', 'NO']
    : ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
  const label = dirs[Math.round(deg / 45) % 8];
  const W = lang === 'pt' ? 'O' : 'W';
  return (
    <div title={(lang === 'pt' ? 'Sentido de marcha' : 'Heading') + `: ${label} · ${Math.round(deg)}°`}
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, flexShrink: 0 }}>
      <svg width={size} height={size} viewBox="0 0 42 42" aria-hidden="true">
        <circle cx="21" cy="21" r="19" fill="#f8fafc" stroke="#e2e8f0" strokeWidth="1" />
        <circle cx="21" cy="21" r="15" fill="none" stroke="#eef2f7" strokeWidth="1" />
        {/* Letras cardeais discretas */}
        <text x="21" y="9.5" textAnchor="middle" fontSize="6.5" fontWeight="700" fill="#94a3b8">N</text>
        <text x="34" y="23.3" textAnchor="middle" fontSize="6.5" fontWeight="700" fill="#cbd5e1">E</text>
        <text x="21" y="37" textAnchor="middle" fontSize="6.5" fontWeight="700" fill="#cbd5e1">S</text>
        <text x="8" y="23.3" textAnchor="middle" fontSize="6.5" fontWeight="700" fill="#cbd5e1">{W}</text>
        {/* Agulha rodada para o heading — metade laranja (frente), cauda cinza */}
        <g transform={`rotate(${deg} 21 21)`}>
          <polygon points="21,7 24.4,21 21,18.2 17.6,21" fill="#f97316" />
          <polygon points="21,35 24.4,21 21,23.8 17.6,21" fill="#cbd5e1" />
          <circle cx="21" cy="21" r="2.1" fill="#fff" stroke="#f97316" strokeWidth="1" />
        </g>
      </svg>
      <span style={{ fontSize: 9, fontWeight: 800, color: '#64748b', letterSpacing: 0.3 }}>{label}</span>
    </div>
  );
}
